module.exports = __webpack_public_path__ + "static/media/P_1.7d514f4e.jpg";